export { parametersGroup } from './data/parameters';
export { viewerGroup } from './data/viewer';
export { texturesGroup } from './data/textures';
export { aiGroup } from './data/ai';
export { editorGroup } from './data/editor';
export { filesGroup } from './data/files';
export { publishingGroup } from './data/publishing';
export { monetizationGroup } from './data/monetization';
export { performanceGroup } from './data/performance';

import { parametersGroup } from './data/parameters';
import { viewerGroup } from './data/viewer';
import { texturesGroup } from './data/textures';
import { aiGroup } from './data/ai';
import { editorGroup } from './data/editor';
import { filesGroup } from './data/files';
import { publishingGroup } from './data/publishing';
import { monetizationGroup } from './data/monetization';
import { performanceGroup } from './data/performance';
import type { FeatureGroup } from './types';

export const FEATURE_GROUPS: FeatureGroup[] = [
  parametersGroup,
  viewerGroup,
  texturesGroup,
  aiGroup,
  editorGroup,
  filesGroup,
  publishingGroup,
  monetizationGroup,
  performanceGroup,
];
